import { useState, useEffect, useContext } from "react";
import ContextStates from "../context/ContextStates";
import axios from "axios";
import { Url } from "./Url";
import { FaPlus } from "react-icons/fa";


const ListadoZonas = () => {
    const { zonas, setZonas, modify, setModify } = useContext(ContextStates)

    // Estado del formulario de nueva zona
    const [mostrarForm, setMostrarForm] = useState(false)
    const [nombre, setNombre] = useState('')
    const [descripcion, setDescripcion] = useState('')
    const [guardando, setGuardando] = useState(false)
    const [error, setError] = useState('')

    useEffect(() => {
        const consultaZonas = async () => {
            const formData = new FormData()
            formData.append("id", 1)
            formData.append("activo", 1)
            try {
                const response = await axios({
                    url: Url + 'api/listZonas.php',
                    method: 'POST',
                    data: formData,
                })
                setZonas(response.data.results)
            } catch (e) {
                console.log(e)
            }
        }
        consultaZonas()
    }, [modify])

    const setEstadoZona = async (item) => {
        const formData = new FormData()
        formData.append("id", item.id)
        formData.append("estado", item.activo)
        try {
            await axios({
                url: Url + 'api/setZona.php',
                method: 'POST',
                data: formData,
            })
            setModify(modify + 1)
        } catch (e) {
            console.log(e)
        }
    }

    const editZona = () => {}

    const handleAltaZona = async () => {
        if (!nombre.trim()) {
            setError('El nombre es obligatorio.')
            return
        }
        setGuardando(true)
        setError('')
        const formData = new FormData()
        formData.append('nombre', nombre.trim())
        formData.append('descripcion', descripcion.trim())
        try {
            await axios({
                url: Url + 'api/altaZona.php',
                method: 'POST',
                data: formData,
            })
            setNombre('')
            setDescripcion('')
            setMostrarForm(false)
            setModify(modify + 1)
        } catch (e) {
            setError('Error al guardar la zona.')
            console.log(e)
        }
        setGuardando(false)
    }

    return (
        <div className="mt-1 mb-10 w-full z-0">

            {/* Botón nueva zona */}
            <div className="flex justify-end mb-4 px-2">
                <button
                    className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-500 text-white font-semibold py-2 px-4 rounded-lg shadow transition-all"
                    onClick={() => { setMostrarForm(!mostrarForm); setError('') }}
                >
                    <FaPlus /> Nueva Zona
                </button>
            </div>

            {/* Formulario de alta */}
            {mostrarForm && (
                <div className="w-full md:w-1/2 mx-auto mb-6 bg-indigo-50 border border-indigo-200 rounded-xl p-5 shadow">
                    <h3 className="text-indigo-700 font-bold text-lg mb-4">Nueva Zona</h3>
                    <div className="mb-3">
                        <label className="block text-sm font-semibold text-gray-700 mb-1">
                            Nombre <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            className="w-full p-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-400"
                            placeholder="Nombre de la zona"
                            value={nombre}
                            onChange={(e) => setNombre(e.target.value)}
                            autoFocus
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block text-sm font-semibold text-gray-700 mb-1">
                            Descripción
                        </label>
                        <input
                            type="text"
                            className="w-full p-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-400"
                            placeholder="Descripción opcional"
                            value={descripcion}
                            onChange={(e) => setDescripcion(e.target.value)}
                        />
                    </div>
                    {error && <p className="text-red-500 text-sm mb-3">{error}</p>}
                    <div className="flex gap-3">
                        <button
                            className="flex-1 bg-indigo-600 hover:bg-indigo-500 text-white font-semibold py-2 rounded-lg transition-all disabled:opacity-50"
                            onClick={handleAltaZona}
                            disabled={guardando}
                        >
                            {guardando ? 'Guardando...' : 'Guardar'}
                        </button>
                        <button
                            className="flex-1 bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold py-2 rounded-lg transition-all"
                            onClick={() => { setMostrarForm(false); setNombre(''); setDescripcion(''); setError('') }}
                        >
                            Cancelar
                        </button>
                    </div>
                </div>
            )}

            {/* Tabla de zonas */}
            {typeof zonas !== 'undefined' && zonas.length > 0 && (
                <div className='w-full'>
                    <table className='w-full mx-auto'>
                        <thead>
                            <tr className='p-1 bg-blue-400 text-white text-center'>
                                <th>Nombre</th>
                                <th>Descripción</th>
                                <th>Estado</th>
                                <th className='print:hidden'>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                zonas.map((item, index) => (
                                    <tr key={index} className={`hover:cursor-pointer hover:bg-slate-200 border-b border-gray-200 text-center ${index % 2 === 0 ? 'bg-white' : 'bg-slate-100'}`}>
                                        <td>{item.nombre}</td>
                                        <td>{item.descripcion}</td>
                                        <td>{item.activo === '0' ? 'Inactiva' : 'Activa'}</td>
                                        <td className="flex p-2">
                                            <button
                                                className={`text-white p-3 w-full rounded ${item.activo === '0' ? 'bg-green-500' : 'bg-red-500'}`}
                                                onClick={() => setEstadoZona(item)}
                                            >{item.activo === '0' ? 'Activar' : 'Desactivar'}</button>
                                            <button
                                                className="bg-orange-600 text-white ml-3 p-3 w-full rounded"
                                                onClick={() => editZona(item)}
                                            >Editar</button>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            )}

        </div>
    )
}

export default ListadoZonas
